import { Database, Kanban, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOCAL_SUPABASE_STUDIO_URL, LOCAL_INBUCKET_URL } from "@/config/local-supabase-ports";
import { useRole } from "@/hooks/useRole";
import { useNavigate } from "@tanstack/react-router";

// Only render in local development
const isLocalDev =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

export function DevToolbar() {
  const { isAdmin } = useRole();
  const navigate = useNavigate();

  if (!isLocalDev) return null;

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        className="border-green-500/50 text-green-500 hover:bg-green-500/10"
        onClick={() => window.open(LOCAL_SUPABASE_STUDIO_URL, "_blank")}
      >
        <Database className="mr-1.5 h-4 w-4" />
        Supabase
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="border-blue-500/50 text-blue-500 hover:bg-blue-500/10"
        onClick={() => window.open(LOCAL_INBUCKET_URL, "_blank")}
      >
        <Mail className="mr-1.5 h-4 w-4" />
        Inbox
      </Button>
      {isAdmin && (
        <Button
          variant="outline"
          size="sm"
          className="border-purple-500/50 text-purple-500 hover:bg-purple-500/10"
          onClick={() => navigate({ to: "/dashboard/roadmap" })}
        >
          <Kanban className="mr-1.5 h-4 w-4" />
          Roadmap
        </Button>
      )}
    </div>
  );
}
